import { Component, OnInit, Output,EventEmitter, Input, OnChanges, SimpleChanges, HostListener  } from '@angular/core';
import {OrderByPipe} from 'ngx-pipes';
import {BuscarEntreFechasPipe} from '../filters/buscar-entre-fechas.pipe';
import{
  LoopBackAuth,
  validacionService,
  pensumService,
  calificacionService,
  ActividadService,
  listadosService} from '../services/api-rest.service';
import{MessageService} from '../services/message.service';
import { ToastrService } from 'ngx-toastr';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import { DatosComplementariosBasicosComponent } from './formularios/datos-complementarios-basicos.component';
import { isNull } from 'util';
@Component({
  selector: 'tabla-asistencia-estudiantes',
  templateUrl: './tabla-asistencia-estudiantes.component.html',
  providers:[
    OrderByPipe,
    LoopBackAuth,
    validacionService,
    pensumService,
    calificacionService,
    ActividadService,
    listadosService,
    MessageService,
    BuscarEntreFechasPipe ]
})
export class TablaAsistenciaEstudiantesComponent implements OnInit {
  @Input() pensum: any
  @Input() asignaturaTipo: any = 1 // 1 calificaciones, 2 observaciones, 3 Asistencia
  @Input() esDueno: any
  @Input() modificarNotas: any
  @Input() spinner: any
  @Input() idQuimestreParcialSelect: number

 // @Output() emittTarea= new EventEmitter()
  @Output() emittCurso= new EventEmitter()
  @Output() emittNivelVer= new EventEmitter()
  @Output() emittActualizarNota= new EventEmitter()
  @Output() emittActivarNotas= new EventEmitter()
  @Output() emittReload= new EventEmitter()
  //@Output() emittModificarColumn = new EventEmitter()

  /* Asistencia V.2.0 */
  @Input() fechaInicio : any
  @Input() fechaFin : any
  @Input()  horasAsignaturaDia : any
  @Output() emittQuimestres= new EventEmitter()
  @Output() emittJustificarFalta = new EventEmitter()
  @Output() emittQuimestre= new EventEmitter()
  @Output() emittParcialesQuimestres= new EventEmitter()
  @Output() emittListarFaltasPorTipo = new EventEmitter()

  alumnos: any = []
  tareas: any
  padreTareas : any
  search: any

  nivel: any = 0
  nivelVer: any = 1
  nodo: any
  activarCaudad : any = false
  reload: boolean = true
  updateNota: boolean
  asistencias: any = []
  tiposAgrupacion: any []

  totales: any []
  sumaTotales:any[] =[]
  arbol: any
  quimestre: any
  asistenciaTipo: any []
  parcialesQuimestres: any []
  defectoAsistenciaTipo : any = []
  calificaciones : any = []
  curso: any


  constructor(
    private orderBy: OrderByPipe,
    private ActividadService: ActividadService,
    private calificacionService: calificacionService,
    private pensumService:pensumService,
    public val: validacionService,
    private toastr: ToastrService,
    private modalService: NgbModal,
    private listadosService: listadosService,
    private buscarFechas: BuscarEntreFechasPipe
  ) { }

  ngOnInit() {
    this.activarCaudad = (this.val.accesoSeccion('secretaria') == null)? true: false
    this.tiposAgrupacion = [
      {id:1, descripcion:'Mensual'},
      {id:2, descripcion:'Semanal'},
      {id:3, descripcion:'Hoy'},
    ]

  }
  ngOnChanges(changes:SimpleChanges) {
    if(changes.pensum != undefined
      && changes.pensum.currentValue != undefined)
        this.armarArbol(changes.pensum.currentValue)



    if((changes.fechaInicio != undefined && changes.fechaInicio.currentValue != undefined)
        || (changes.fechaFin != undefined && changes.fechaFin.currentValue != undefined) )
          this.calcularTotales()
  }



  @HostListener("window:scroll", ['$event'])
  doSomethingOnWindowsScroll($event:Event){
    //console.log($event)
    //let scrollOffset = $event.srcElement.children[0].scrollTop;
    //console.log("window scroll: ", scrollOffset);
  }

  colorAbreviatura(item) {
    if(!this.esDueno) return '#c6c6c6'
    let numeroDia =  new Date(item.fecha_tarea.split("-")[0],(item.fecha_tarea.split("-")[1]-1), item.fecha_tarea.split("-")[2]).getDay()
    let buscarDia =  this.horasAsignaturaDia.filter(x=> x.numero_dia == numeroDia)

    if(this.curso.utiliza_horario )
      if(buscarDia == undefined || buscarDia.length == 0)
        return '#4f4f4f'

    if(this.validarFechasApertura(item))  return '#4680ff'
    return '#c6c6c6'
  }

  validarFechasApertura(item){
      if(!this.esDueno) return false
      //console.log("fechas -->P",item.fecha_cierre_secretaria,item.fecha_cierre_secretaria)
      if(item.fecha_cierre_secretaria == null || item.fecha_cierre_secretaria == null) return false
      let activar = false
      let acceso = (this.val.accesoSeccion('administrador')!= null) ? this.val.accesoSeccion('administrador') :(this.val.accesoSeccion('secretaria')!= null) ? this.val.accesoSeccion('secretaria'): 0
      let inicio : any
      let fin : any
      let fecha : any

      switch(acceso){
        case 1:
        case 3:
          inicio = new Date(item.fecha_apertura_secretaria)
          fin = new Date(item.fecha_cierre_secretaria)
          fecha = new Date()
          if(fecha >= inicio.getTime() && fecha <= fin.getTime())
            activar = true
        break;
        default:
          inicio = new Date(item.fecha_apertura_docente)
          fin = new Date(item.fecha_cierre_docente)
          fecha = new Date()
          if(fecha >= inicio.getTime() && fecha <= fin.getTime())
            activar = true
      }
      return activar
  }

  armarArbol(idPensum : any){
    this.spinner.isSpinnerVisible = true
    this.listadosService.listaAsistenciaTipo().subscribe(
      resultado => {
        this.asistenciaTipo = resultado
        this.defectoAsistenciaTipo = resultado.filter((x:any)=> {
          return  x.predeterminado == true
        })

      }
    )
    this.ActividadService.tareaAutomatica(idPensum).subscribe(
      item =>{
        if(item != null){

          this.pensumService.estudiantesPensum(idPensum).subscribe(
            alumnos =>{
              if(isNaN(alumnos)){

                this.ActividadService.arbol(idPensum, this.asignaturaTipo).subscribe(
                  actividades => {
                    if(isNaN(actividades)){
                     console.log("***Actividades -->", actividades)
                      this.emittCurso.emit(actividades[0])
                      this.curso = actividades[0]
                      this.parcialesQuimestres = actividades.filter(x=> x.fecha_inicial_asistencia != null || x.fecha_final_asistencia != null).sort((a, b) => a.orden - b.orden);
                      this.arbol = this.val.construirArbol(actividades)
                      console.log("***Arbol aistencia -->", this.arbol )
                      this.calificacionService.calificacionPensum(idPensum, this.asignaturaTipo).subscribe(
                        calificaciones =>{
                          if(isNaN(calificaciones)){
                            this.calificaciones = calificaciones
                            this.contruirAsistencias(this.arbol,0,alumnos,calificaciones,idPensum,null);
                            this.alumnos = this.arbol[0].notas
                            if(isNull(this.idQuimestreParcialSelect) || this.idQuimestreParcialSelect == undefined || this.idQuimestreParcialSelect == 0){
                              this.quimestre =  this.buscarTaresdeParciales(this.arbol,this.arbol[0].id)
                              console.log("*Lista quimestre 1 -->", this.quimestre )
                              this.emittQuimestres.emit(this.parcialesQuimestres)
                              this.emittQuimestre.emit(this.quimestre)
                              this.emittParcialesQuimestres.emit(this.parcialesQuimestres)
                            }else{
                              this.quimestre =  this.buscarTaresdeParciales(this.arbol,this.idQuimestreParcialSelect)
                              console.log("*Lista quimestre 2 -->", this.quimestre )
                              this.emittQuimestres.emit(this.parcialesQuimestres)
                              this.emittQuimestre.emit(this.quimestre)
                              this.emittParcialesQuimestres.emit(this.parcialesQuimestres)
                            }
                            console.log("***parcialesQuimestres -->", this.parcialesQuimestres)
                            this.calcularTotales()
                          }
                          this.spinner.isSpinnerVisible = false
                          this.emittReload.emit()

                        }
                      )
                    }else{
                      this.spinner.isSpinnerVisible = false
                      this.emittReload.emit()
                    }
                  }
                )
              }
            }
          )
        }

      }
    )
  }

  calcularTotales(){
    let tareasFechas = this.buscarFechas.transform(this.quimestre,this.fechaInicio,this.fechaFin)
      for(let alumno of this.alumnos){
        let calificacionesMatricula = this.calificaciones.filter(x=> x.aca_matricula_id  == alumno.alumno)
        let asistencias =[]
        for(let tarea of tareasFechas){
          for(let calificacionMatricula of calificacionesMatricula){
            if(calificacionMatricula.aca_actividad_id == tarea.id){
              asistencias.push(calificacionMatricula)
            }
          }
        }
        let total = []
        for(let tipo of this.asistenciaTipo){
          let datos = asistencias.filter((x:any) => x.aca_asistencia_periodo_id == tipo.aca_asistencia_periodo_id)
          let suma = 0
          for(let asistencia of datos ){
            suma = suma +  parseFloat(asistencia.calificacion)
          }
          total.push({
            valor: suma,
            aca_asistencia_periodo_id: tipo.aca_asistencia_periodo_id ,
            aca_asistencia_tipo_color: tipo.color,
            descripcion: tipo.descripcion,
            idMatricula: alumno.alumno
          })
        }
        if(this.sumaTotales.length != 0){
          this.sumaTotales[0].valor += total[0].valor
          this.sumaTotales[1].valor += total[1].valor
          this.sumaTotales[2].valor += total[2].valor
        }else{
          this.sumaTotales = total
        }
        alumno.totales = total
      }



  }

  contruirAsistencias(ramas,nivel, alumnos, calificaciones, pesum, padre){
    nivel = nivel + 1
    if(ramas.length > 0){
      let count = 0
      for(let rama of ramas){
        rama.notas = this.estructuraAsistencia(alumnos, calificaciones, pesum, rama, padre)
        this.contruirAsistencias(rama.children,nivel, alumnos, calificaciones, pesum, rama)
      }
    }else{
      return null
    }
  }

  estructuraAsistencia(alumnos, calificaciones, pensum, tarea, padre,){
    let notas = []
    for(let alumno of alumnos){
      let items = calificaciones.filter(x=> x.aca_matricula_id == alumno.aca_matricula_id &&  x.aca_docente_asignatura_curso_id == pensum && x.aca_actividad_id == tarea.id)
      let numero_decimal = tarea.numero_decimal
      let asistencias = []
      for(let item of items){
        asistencias.push({
          id: item.aca_calificacion_id,
          nota: parseFloat(item.calificacion).toFixed(numero_decimal),
          alumno: alumno.aca_matricula_id,
          descripcion:alumno.estudiante,
          numero_decimal: numero_decimal,
          actividad_activa: alumno.actividad_activa,
          aca_actividad_id: item.aca_actividad_id,
          aca_asistencia_periodo_id: item.aca_asistencia_periodo_id,
          aca_asistencia_tipo_abreviatura:item.aca_asistencia_tipo_abreviatura,
          aca_asistencia_tipo_color:item.aca_asistencia_tipo_color,
          aca_asistencia_tipo_descripcion: item.aca_asistencia_tipo_descripcion,
          aca_asistencia_tipo_orden: item.aca_asistencia_tipo_orden,
          aca_calificacion_id: item.aca_calificacion_id,
          aca_curso_completo_id:item.aca_curso_completo_id,
          aca_docente_asignatura_curso_id: item.aca_docente_asignatura_curso_id,
          aca_matricula_id: item.aca_matricula_id,
          fecha_apertura_secretaria: tarea.fecha_apertura_secretaria,
          fecha_cierre_secretaria: tarea.fecha_cierre_secretaria,
          fecha_apertura_docente: tarea.fecha_apertura_secretaria,
          fecha_cierre_docente: tarea.fecha_cierre_secretaria,
          fecha_tarea: tarea.fecha_tarea,
          observacion: item.observacion
        })
      }
      if(asistencias.length == 0){
        /** Aqui puedo asignar el numero de horas que tenga en mi horario y generar mi estructura base de asistencia */

        asistencias.push({
          id: null,
          nota: 0,
          alumno: alumno.aca_matricula_id,
          descripcion:alumno.estudiante,
          numero_decimal: numero_decimal,
          actividad_activa: tarea.id,
          aca_actividad_id:  tarea.id,
          aca_asistencia_periodo_id: null,
          aca_asistencia_tipo_abreviatura: null,
          aca_asistencia_tipo_color: null,
          aca_asistencia_tipo_descripcion: null,
          aca_asistencia_tipo_orden: null,
          aca_calificacion_id: null,
          aca_curso_completo_id: null,
          aca_docente_asignatura_curso_id: null,
          aca_matricula_id: alumno.aca_matricula_id,
          fecha_apertura_secretaria: tarea.fecha_apertura_secretaria,
          fecha_cierre_secretaria: tarea.fecha_cierre_secretaria,
          fecha_apertura_docente: tarea.fecha_apertura_secretaria,
          fecha_cierre_docente: tarea.fecha_cierre_secretaria,
          fecha_tarea: tarea.fecha_tarea,
          observacion: null
        })
      }
      notas.push({
        alumno: alumno.aca_matricula_id,
        descripcion:alumno.estudiante,
        aca_actividad_id:tarea.id,
        asistencias: asistencias,
        estado_alumno: alumno.estado,
        totales:[]
      })


    }
    return notas
  }

  cambiarVistaQuimestreSeleccionado(idQuimestre){
    this.quimestre = []
    this.quimestre =  this.buscarTaresdeParciales(this.arbol,idQuimestre)
    this.emittQuimestre.emit(this.quimestre)
  }

  justificarFalta(item){
    console.log("Asistencai PPP",item)
    let parament = {
      nota:item,
      tipo: this.asistenciaTipo
    }
    this.emittJustificarFalta.emit(parament)
  }

  onAsignarFalta(tarea : any, calificacion :any, estadoAlumno: any){
    let numeroDia =  new Date(tarea.fecha_tarea.split("-")[0],(tarea.fecha_tarea.split("-")[1]-1), tarea.fecha_tarea.split("-")[2]).getDay()
    console.log("numero dias -->", numeroDia, calificacion)
    let buscarDia =  this.horasAsignaturaDia.filter(x=> x.numero_dia == numeroDia)
    console.log("buscar dia -->", buscarDia)
    console.log("Utilizar horario -->", this.curso.utiliza_horario)
    let activarHorario  = (this.curso.utiliza_horario) ? (buscarDia != undefined && buscarDia.length > 0) ? true : false : true
    console.log("Curso **** -->",
    this.defectoAsistenciaTipo.length > 0
    ,this.esDueno
    ,estadoAlumno != 'R'
    ,this.validarFechasApertura(calificacion)
    , activarHorario)

    if( this.defectoAsistenciaTipo.length > 0
        && this.esDueno
        && estadoAlumno != 'R'
        && this.validarFechasApertura(calificacion) && activarHorario){
      this.calificacionService.asignarCalificacionEstudianteMateria(
          this.pensum,
          calificacion.aca_matricula_id,
          calificacion.actividad_activa,
          calificacion.id,
          1,
          calificacion.observacion,
          this.defectoAsistenciaTipo[0].aca_asistencia_periodo_id
          ).subscribe(
        result=>{
          if(result != null){
            this.armarArbol(this.pensum)
          }
        }
      )
    }
  }


  celdaModificar(tarea, calificacion){
    if(calificacion.nota >= tarea.rango_inicial  && calificacion.nota <= tarea.rango_final ){
      this.updateNota = true
      this.emittActualizarNota.emit(2)
      this.calificacionService.asignarCalificacionEstudianteMateria(this.pensum, calificacion.alumno,calificacion.aca_actividad_id,calificacion.id, calificacion.nota, calificacion.observacion).subscribe(
        item =>{
          console.log("respuesat de funcion", item)
          if(item != null){
            calificacion.id = item
            this.emittActualizarNota.emit(1)
            this.calcularColumna(tarea)
          }else{
            this.emittActualizarNota.emit(0)
          }
          this.updateNota = false

        }
      )
    }else{
      this.toastr.error("La nota de "+calificacion.descripcion+" no fue ingresa poque no cumple con el rango de "+ tarea.rango_inicial +" a "+ tarea.rango_final,"Error" )
      calificacion.nota = 0
    }

  }



  calcularColumna(tarea){
    let total = 0.00
    for(let item of tarea.notas){
      total  = total + parseFloat(item.nota)
    }
    tarea.total = (total / tarea.notas.length).toFixed(2)
  }

  /*outputTarea(tarea){
    if(this.val.accsesoTareas(tarea)){
      this.emittTarea.emit(tarea)
    }else{
      this.toastr.warning("Esta fuera del rango de fechas", "Alerta")
    }
  }*/

  listaTareas(){
    return this.tareas
  }

  addTareas(item){
    item.notas = this.nodo.notas
    this.asistencias.push(item)
  }

  deletTarea(idTarea){
    let index  = this.tareas.findIndex(element=> element.id == idTarea)
    this.tareas.splice(index, 1)
  }

  buscarTaresdeParciales(arbol: any, idQuimestre :any){
    let datos = this.buscarNodo(arbol, idQuimestre)
    let parciales = []
    console.log("Dastos buscardo nodo", datos)
    if(datos.nodoPapa == null){
      parciales = datos.children
    }else{
      parciales = this.buscarNodo(arbol, datos.nodoPapa).children
    }
    let tareas = []
    for(let i=0; i< parciales.length; i++){
      for(let j=0; j< parciales[i].children.length; j++){
        parciales[i].children[j]["fecha"] = new Date(parciales[i].children[j]["fecha_tarea"]).getTime()
        tareas.push(parciales[i].children[j] )
      }
    }
    return this.orderBy.transform(tareas,'fecha')
  }

  private buscarNodo(ramas : any, idBuscar: any){
    if(idBuscar == null)  return null
    if(ramas.length == 0) return null
    let datos = ramas.filter((x: any)=> x.id == idBuscar)
    if(datos != undefined && datos.length > 0){
      return datos[0]
    }else{
      for(let rama of ramas){
        let datos = this.buscarNodo(rama.children, idBuscar)
        if(datos != null) return datos
      }
    }
  }



}



// WEBPACK FOOTER //
// ./src/app/shared/element/tabla-asistencia-estudiantes.component.ts